import OrderedList from './List.Ordered'
import UnorderedList from './List.Unordered'

export default {
  ol: OrderedList,
  ul: UnorderedList
}
